import script from "./Menus.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menus.vue?vue&type=script&lang=ts&setup=true"

import "./Menus.vue?vue&type=style&index=0&id=1c7fd98e&lang=less&scoped=true"
import "./Menus.vue?vue&type=style&index=1&id=1c7fd98e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7fd98e"]])

export default __exports__